<!-- Просмотр через действие или маршрут, с возможностью сохранить текущую форму в отдельной вкладке -->
<template>
  <component :is="to ? 'RouterLink' : 'button'" class="base-view-icon-button"
    :to="to || undefined" :type="to ? undefined : 'button'"
    :target="to && newTab ? '_blank' : undefined" :rel="to && newTab ? 'noopener noreferrer' : undefined"
    :title="title" :aria-label="title" @click="$emit('click', $event)">
    <AppIcon name="eye" :size="20" />
  </component>
</template>
<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
export default {
  name: "BaseViewIconButton",
  components: { AppIcon },
  props: {
    to: { type: [String, Object], default: null },
    newTab: { type: Boolean, default: false },
    title: { type: String, default: "Просмотр" },
  },
  emits: ["click"],
};
</script>
<style scoped>
.base-view-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  padding: 0;
  border: none;
  border-radius: 6px;
  color: #6b7280;
  background: none;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.base-view-icon-button:hover { background: #dbeafe; color: var(--color-blue); }
.base-view-icon-button:disabled { cursor: not-allowed; opacity: 0.55; }
</style>
